import { createFileRoute } from "@tanstack/react-router";
import { MobileProfilePage } from "@/components/mobile-profile";

export const Route = createFileRoute("/(protected)/profile/")({
  component: MobileProfilePage,
});
